export class BlobFileApiModel {
  public OriginalFileName: string;
  public ContentType: string;
  public Link: string;

  public deserialize(data: Object): BlobFileApiModel {
    return Object.assign(new BlobFileApiModel(), data);
  }

  public download(inNewTab = true): void {
    const a = document.createElement('a');
    const encodedFileName = encodeURIComponent(this.OriginalFileName);

    a.setAttribute('href', this.Link + `&fileName=${encodedFileName}`);
    a.setAttribute('download', this.OriginalFileName);
    a.style.display = 'none';

    if (inNewTab) {
      a.setAttribute('target', '_blank');
    }

    document.body.appendChild(a);

    a.click();

    document.body.removeChild(a);
  }
}
